import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'historique-envois',
  templateUrl: './historique-envois.component.html',
  styleUrls: ['./historique-envois.component.scss']
})
export class HistoriqueEnvoisComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
